import { render, staticRenderFns } from "./departMember.vue?vue&type=template&id=66a65b3a&scoped=true&"
import script from "./departMember.vue?vue&type=script&lang=js&"
export * from "./departMember.vue?vue&type=script&lang=js&"
import style0 from "./departMember.vue?vue&type=style&index=0&id=66a65b3a&prod&scoped=true&lang=css&"
import style1 from "./departMember.vue?vue&type=style&index=1&id=66a65b3a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a65b3a",
  null
  
)

export default component.exports